<ion-app>
  @if (connectionUnavailableScreenService.isConnectionUnavailable()) {
    <app-connection-unavailable-screen></app-connection-unavailable-screen>
  } @else if (serviceUnavailableScreenService.isServiceUnavailable()) {
    <app-service-unavailable-screen></app-service-unavailable-screen>
  } @else {
    <div class="ion-page p-0" id="main-content">

    <ion-content [fullscreen]="true">
      <app-mobile-blocker *ngIf="isMobileBrowser"></app-mobile-blocker>
      <ion-router-outlet *ngIf="!isMobileBrowser" id="router-content"></ion-router-outlet>
      <app-auth-brand-intro></app-auth-brand-intro>
    </ion-content>
  </div>
  }
</ion-app>
